import React, { useState, useEffect } from "react";
import { showError } from "../../ui/Message";
import { pubCall } from "../../utils/PubSub";
import VirtualTable from "../../ui/VirtualTable";
import { drawPrice, moveItem } from "../../utils/Utils";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
export default function OrderTotalsBySection(props) {

    const { controller = "", route = "", item = {}, callback = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("auto");
    const row_key = "section";



    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("purchase_order.viewTotalsBySection", { purchase_order_id: item?.purchase_order_id }, (_s, _r) => {
            if (_s) {

                setData(_r);


                setSelected((_r.length > 0) ? _r[0] : {})

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);



    useEffect(() => {
        window.bm_state.value = route;
        const cleanup = listen(controller, route, [ { key: KBD.ESCAPE, action: () => { callback(false) } },]);
        return cleanup;
    }, [selected])



    const columns = [

        { width: 100, key: "order_number", grow: true, align: "left", title: <>PO#</> },
        { width: 100, key: "supplier_code", align: "left", title: <>Supl</> },
        { width: 35, key: "section", align: "left", title: <>Se</> },
        { width: 60, key: "titles_count", align: "right", title: <>Titles</> },
        { width: 35, key: "separator", align: "left", title: <>Grp</> },
        { width: 70, key: "unit_count", align: "right", title: <>Units</> },
        { width: 80, key: "list_price_total", align: "right", title: <>List</>, render: (e) => drawPrice(e, true) },
        { width: 80, key: "net_price_total", align: "right", title: <>Net</>, render: (e) => drawPrice(e, true) },

    ];



    const move = (rows = 1) => {
        moveItem({ data: data, selected, setSelected, row_key, step: rows, setAlign, alignOnMove: true });
    }




    return (<>

        <div style={{ "width": "580px" }}>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                next={(e) => move((e) ? e : 1)}
                prev={(e) => move((e) ? e * -1 : -1)}

                align={align}
                row_key={row_key}
                current={selected}
                data={data}
                height={251}
                columns={columns}
                width={0}
                loading={loading}
                offset={430}
                route={route}
            />
        </div>

    </>)
}